import { render, staticRenderFns } from "./alpha-slider.vue?vue&type=template&id=35642a8f&"
import script from "./alpha-slider.vue?vue&type=script&lang=js&"
export * from "./alpha-slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35642a8f')) {
      api.createRecord('35642a8f', component.options)
    } else {
      api.reload('35642a8f', component.options)
    }
    module.hot.accept("./alpha-slider.vue?vue&type=template&id=35642a8f&", function () {
      api.rerender('35642a8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DesignEditor/component/common/color-picker/src/components/alpha-slider.vue"
export default component.exports